export const insightsData = [
  {
    id: 1,
    title: '외국계 기업 면접에서 자주 나오는 질문 TOP 10',
    summary: '실제 면접에서 가장 많이 나오는 질문들과 효과적인 답변 전략을 소개합니다. 준비된 답변으로 자신감 있게 면접에 임하세요.',
    category: '면접 준비',
    date: '2024년 1월 15일',
    readTime: '8분',
    image: 'https://public.readdy.ai/ai/img_res/a8cc5f93a9b3c7060899e76c375abff6.jpg',
  },
  {
    id: 2,
    title: '글로벌 기업이 원하는 이력서 작성법',
    summary: 'ATS를 통과하고 채용 담당자의 눈길을 사로잡는 이력서 작성 노하우를 공유합니다. 실제 합격 사례를 바탕으로 한 실용적인 팁.',
    category: '이력서',
    date: '2024년 1월 12일',
    readTime: '10분',
    image: 'https://readdy.ai/api/search-image?query=modern%20professional%20resume%20document%20on%20clean%20desk%20with%20laptop%20and%20coffee%20in%20bright%20minimalist%20workspace%20featuring%20contemporary%20business%20stationery%20and%20elegant%20office%20supplies&width=800&height=600&seq=insight002&orientation=landscape',
  },
  {
    id: 3,
    title: '국내 기업에서 외국계로 성공적인 이직 전략',
    summary: '국내 기업 경력을 글로벌 기업에서 어필하는 방법과 문화적 차이를 극복하는 실질적인 조언을 제공합니다.',
    category: '커리어 전환',
    date: '2024년 1월 10일',
    readTime: '12분',
    image: 'https://readdy.ai/api/search-image?query=career%20transition%20concept%20with%20modern%20business%20professional%20walking%20towards%20bright%20future%20in%20contemporary%20office%20corridor%20with%20clean%20architecture%20and%20natural%20light%20symbolizing%20new%20opportunities&width=800&height=600&seq=insight003&orientation=landscape',
  },
  {
    id: 4,
    title: '2024년 외국계 기업 채용 트렌드 분석',
    summary: '올해 외국계 기업들의 채용 동향과 선호하는 인재상을 분석합니다. 업계별 특징과 준비 전략을 확인하세요.',
    category: '업계 인사이트',
    date: '2024년 1월 8일',
    readTime: '15분',
    image: 'https://readdy.ai/api/search-image?query=business%20analytics%20and%20trends%20visualization%20with%20modern%20data%20charts%20on%20digital%20screens%20in%20contemporary%20office%20environment%20featuring%20clean%20design%20and%20professional%20corporate%20atmosphere&width=800&height=600&seq=insight004&orientation=landscape',
  },
  {
    id: 5,
    title: '영어 면접 준비: 실전 시뮬레이션 가이드',
    summary: '영어 면접에서 자주 실수하는 부분과 이를 극복하는 방법을 실전 예시와 함께 설명합니다.',
    category: '면접 준비',
    date: '2024년 1월 5일',
    readTime: '9분',
    image: 'https://readdy.ai/api/search-image?query=english%20language%20learning%20and%20business%20communication%20with%20professional%20materials%20and%20modern%20study%20setup%20in%20bright%20clean%20workspace%20featuring%20contemporary%20educational%20resources&width=800&height=600&seq=insight005&orientation=landscape',
  },
  {
    id: 6,
    title: '링크드인 프로필 최적화로 헤드헌터 어필하기',
    summary: '헤드헌터들이 주목하는 링크드인 프로필 작성법과 네트워킹 전략을 소개합니다.',
    category: '이력서',
    date: '2024년 1월 3일',
    readTime: '7분',
    image: 'https://readdy.ai/api/search-image?query=professional%20networking%20and%20linkedin%20profile%20on%20laptop%20screen%20in%20modern%20office%20workspace%20with%20clean%20minimalist%20design%20and%20contemporary%20business%20environment&width=800&height=600&seq=insight006&orientation=landscape',
  },
  {
    id: 7,
    title: '외국계 기업 문화 적응 가이드',
    summary: '외국계 기업의 독특한 문화와 업무 방식을 이해하고 빠르게 적응하는 방법을 알려드립니다.',
    category: '커리어 전환',
    date: '2024년 1월 1일',
    readTime: '11분',
    image: 'https://readdy.ai/api/search-image?query=diverse%20international%20business%20team%20collaboration%20in%20modern%20office%20with%20multicultural%20professionals%20working%20together%20in%20bright%20contemporary%20workspace%20with%20clean%20design&width=800&height=600&seq=insight007&orientation=landscape',
  },
  {
    id: 8,
    title: '산업별 외국계 기업 연봉 가이드 2024',
    summary: '업계별 평균 연봉과 협상 전략을 데이터 기반으로 분석합니다. 합리적인 연봉 협상을 위한 필수 정보.',
    category: '업계 인사이트',
    date: '2023년 12월 28일',
    readTime: '13분',
    image: 'https://readdy.ai/api/search-image?query=salary%20negotiation%20and%20financial%20planning%20concept%20with%20professional%20documents%20and%20calculator%20on%20clean%20modern%20desk%20in%20bright%20office%20environment&width=800&height=600&seq=insight008&orientation=landscape',
  },
  {
    id: 9,
    title: '커버레터 작성의 모든 것',
    summary: '채용 담당자의 관심을 끄는 효과적인 커버레터 작성법과 실제 합격 사례를 공유합니다.',
    category: '이력서',
    date: '2023년 12월 25일',
    readTime: '8분',
    image: 'https://readdy.ai/api/search-image?query=professional%20cover%20letter%20writing%20with%20elegant%20stationery%20and%20laptop%20on%20clean%20minimalist%20desk%20in%20bright%20modern%20workspace%20with%20contemporary%20office%20supplies&width=800&height=600&seq=insight009&orientation=landscape',
  },
];
